/* NT Beauty — dual-handle price slider layered on Horizon's price facet.
   Syncs with the native min/max inputs and dispatches change so the
   native price-facet-component re-filters. Re-inits on AJAX/drawer updates. */
(function () {
  /* Strip thousands apostrophes first (CHF 1'000 / 1’000): parseFloat stopped at the
     apostrophe and the slider's range max collapsed to ~1 for any price past a thousand. */
  function num(v, d) { var n = parseFloat(String(v).replace(/['’\s]/g, '').replace(',', '.')); return isNaN(n) ? d : n; }

  function init(comp) {
    /* Guard on the injected element, not a dataset flag: Horizon's facet morph patches the
       component's children in place, which strips our slider wrapper while the flag on the
       surviving component said "already initialised" — so after the first AJAX filter the
       slider was gone for good. Re-running init on unchanged components stays cheap and the
       duplicate change-listeners on the native inputs are idempotent syncs. */
    if (comp.querySelector('.nt-price-slider')) return;
    var minInput = comp.querySelector('[ref="minInput"]');
    var maxInput = comp.querySelector('[ref="maxInput"]');
    if (!minInput || !maxInput) return;

    var rangeMin = 0;
    var rangeMax = Math.ceil(num(maxInput.getAttribute('data-max'), num(maxInput.placeholder, 100)));
    if (rangeMax <= rangeMin) rangeMax = rangeMin + 1;
    var curMin = Math.max(rangeMin, num(minInput.value, rangeMin));
    var curMax = Math.min(rangeMax, num(maxInput.value, rangeMax));

    var wrap = document.createElement('div');
    wrap.className = 'nt-price-slider';
    wrap.innerHTML =
      '<div class="nt-ps-track"><div class="nt-ps-fill"></div></div>' +
      '<input type="range" class="nt-ps-range nt-ps-min" min="' + rangeMin + '" max="' + rangeMax + '" step="1" value="' + curMin + '" aria-label="Minimalpreis">' +
      '<input type="range" class="nt-ps-range nt-ps-max" min="' + rangeMin + '" max="' + rangeMax + '" step="1" value="' + curMax + '" aria-label="Maximalpreis">';

    var iw = comp.querySelector('.facets__inputs-wrapper') || comp.firstElementChild;
    iw.parentNode.insertBefore(wrap, iw);

    var rMin = wrap.querySelector('.nt-ps-min'),
        rMax = wrap.querySelector('.nt-ps-max'),
        fill = wrap.querySelector('.nt-ps-fill');

    function pct(v) { return ((v - rangeMin) / (rangeMax - rangeMin)) * 100; }
    function paint() {
      var a = Math.min(+rMin.value, +rMax.value), b = Math.max(+rMin.value, +rMax.value);
      fill.style.left = pct(a) + '%';
      fill.style.right = (100 - pct(b)) + '%';
      // whichever thumb is on top for clicks near the ends
      rMin.style.zIndex = (+rMin.value >= rangeMax - (rangeMax - rangeMin) * 0.02) ? 5 : 3;
    }
    paint();

    function drag(which) {
      if (which === 'min') {
        if (+rMin.value > +rMax.value) rMin.value = rMax.value;
        minInput.value = Math.round(+rMin.value);
      } else {
        if (+rMax.value < +rMin.value) rMax.value = rMin.value;
        maxInput.value = Math.round(+rMax.value);
      }
      paint();
    }
    function commit(input) { input.dispatchEvent(new Event('change', { bubbles: true })); }

    rMin.addEventListener('input', function () { drag('min'); });
    rMax.addEventListener('input', function () { drag('max'); });
    rMin.addEventListener('change', function () { drag('min'); commit(minInput); });
    rMax.addEventListener('change', function () { drag('max'); commit(maxInput); });
    // keep slider in sync if the native inputs change (typed value, cleared, etc.)
    minInput.addEventListener('change', function () { rMin.value = num(minInput.value, rangeMin); paint(); });
    maxInput.addEventListener('change', function () { rMax.value = num(maxInput.value, rangeMax); paint(); });
  }

  function scan(root) {
    (root || document).querySelectorAll && (root || document).querySelectorAll('price-facet-component').forEach(init);
  }

  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', function () { scan(); });

  // Re-init after AJAX filter updates / mobile drawer open. Horizon MORPHS the facet DOM in
  // place: our injected wrapper is removed without any price-facet-component node ever being
  // ADDED, so scanning addedNodes alone never saw the loss. Debounced full rescan instead —
  // scan() bails per-component when the slider is still present, so this stays cheap.
  /* Only pages that can contain a price facet get a document-wide observer — it was running
     on the PDP, cart and homepage, scanning every mutation for a component that never exists. */
  var ntScanPending = null;
  /* Guard the OBSERVER only, never the rest of the file: an early return here would have skipped
     the rail's add-to-cart handler below on exactly the page that needs it — the homepage has no
     price facet. */
  if (document.querySelector('price-facet-component, .facets, #ProductGridContainer, facets-form-component'))
  new MutationObserver(function () {
    if (ntScanPending) return;
    ntScanPending = setTimeout(function () { ntScanPending = null; scan(); }, 120);
  }).observe(document.documentElement, { childList: true, subtree: true });

  /* [rail quick-add] The plain POST navigated the whole page to /cart — and on touch devices the
     rail's button is permanently visible, making that the homepage's primary add path throwing
     people off the page they were browsing. Intercept, add via AJAX, then dispatch Horizon's own
     cartLinesUpdate event (name and shape from the @shopify/events module the import map
     provides — dynamic import resolves through import maps even from this classic script) so the
     cart bubble updates and the cart drawer auto-opens exactly as for the native product form.
     Every failure path falls back to the original form POST, which also remains the no-JS path. */
  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest ? e.target.closest('.nt-rc-addform') : null;
    if (!form || !window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('.nt-rc-add');
    var idInput = form.querySelector('[name="id"]');
    if (!idInput) { form.submit(); return; }
    if (btn) btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(idInput.value), quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
      .then(function () { return fetch('/cart.js', { headers: { Accept: 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return import('@shopify/events').then(function (m) {
          var ev = new Event(m.StandardEvents.cartLinesUpdate, { bubbles: true });
          ev.action = 'add';
          ev.promise = Promise.resolve({
            cart: { totalQuantity: cart.item_count },
            detail: { itemCount: cart.item_count, source: 'nt-product-rail', sourceId: 'nt-rail' }
          });
          form.dispatchEvent(ev);
        }).catch(function () { /* events module unavailable: item is in the cart, bubble catches up on next navigation */ });
      })
      .then(function () {
        if (btn) {
          btn.disabled = false;
          var label = btn.textContent;
          btn.textContent = '✓ Hinzugefügt';
          setTimeout(function () { btn.textContent = label; }, 2000);
        }
      })
      .catch(function () { if (btn) btn.disabled = false; form.submit(); });
  });
})();
